import { g as t, d as i } from "../../chunks/config.DpwjsOs3.js";
const r = {
  httpOnly: !0,
  secure: !0,
  sameSite: "lax",
  path: "/"
}, z = () => {
  const e = {};
  return window.location.search.substring(1).split("&").forEach((s) => {
    const [a, l] = s.split("=");
    a && (e[decodeURIComponent(a)] = decodeURIComponent(l || ""));
  }), e;
};
function E(e, o) {
  C(o);
  const n = t("ClaimToken"), s = t("ClaimUsername"), a = typeof e[n] == "string" ? e[n] : "";
  if (!a)
    throw new Error("Unable to determine MHO token");
  const l = typeof e[s] == "string" ? e[s] : "";
  if (!l)
    throw new Error("Unable to determine username");
  const c = [
    i.serialize(t("CookieMhoToken"), a, r),
    i.serialize(t("CookieUsername"), l, r)
  ], p = e[t("ClaimIsLinkingSuccessful")], g = e[t("ClaimIsMinorEnrollment")], m = e[t("ClaimAutoEnrollmentErrorMessage")], f = typeof m == "string" && m.trim().length > 0 ? m.trim() : "undefined", u = { ...r, httpOnly: !1 };
  c.push(
    i.serialize(
      t("CookieIsLinkingSuccessful"),
      k(p),
      u
    )
  ), c.push(
    i.serialize(
      t("CookieIsMinorEnrollment"),
      k(g),
      u
    )
  ), c.push(
    i.serialize(
      t("CookieAutoEnrollmentErrorMessage"),
      f,
      u
    )
  ), o.setHeader("Set-Cookie", c);
}
function M(e, o, n) {
  C(n);
  const s = [
    i.serialize(t("CookieMhoToken"), e, r),
    i.serialize(t("CookieUsername"), o, r)
  ];
  n.setHeader("Set-Cookie", s);
}
function y(e, o, n, s) {
  const a = [
    i.serialize(t("CookieMhoToken"), e, { ...r, ...s }),
    i.serialize(t("CookieMhoId"), o, { ...r, ...s })
  ];
  n.setHeader("Set-Cookie", a);
}
function U(e, o) {
  const n = [i.serialize(e, "", { ...r, maxAge: 0 })];
  o.setHeader("Set-Cookie", n);
}
function C(e) {
  const o = [
    i.serialize(t("CookieMhoToken"), "", { ...r, maxAge: 0 }),
    i.serialize(t("CookieUsername"), "", { ...r, maxAge: 0 }),
    i.serialize(t("CookieSkipPhone"), "", { ...r, maxAge: 0 }),
    i.serialize("lastUserActivity", "", { path: "/", maxAge: 0 }),
    i.serialize(t("CookieIsLinkingSuccessful"), "", {
      ...r,
      httpOnly: !1,
      maxAge: 0
    }),
    i.serialize(t("CookieIsMinorEnrollment"), "", {
      ...r,
      httpOnly: !1,
      maxAge: 0
    }),
    i.serialize(t("CookieAutoEnrollmentErrorMessage"), "", {
      ...r,
      httpOnly: !1,
      maxAge: 0
    })
  ];
  e.setHeader("Set-Cookie", o);
}
const d = (e) => {
  const o = document.cookie.split("; ");
  for (const n of o) {
    const [s, ...a] = n.split("=");
    if (s === e)
      return decodeURIComponent(a.join("="));
  }
}, h = (e, o, n = {}) => {
  const s = i.serialize(e, o, { ...r, ...n });
  typeof document < "u" && (document.cookie = s);
}, x = (e, o = {}) => {
  h(e, "", { ...o, maxAge: -1 });
};
function k(e) {
  return e === !0 || e === "true" ? "true" : e === !1 || e === "false" ? "false" : "undefined";
}
const S = () => Date.now(), I = () => {
  const e = /* @__PURE__ */ new Date(), o = e.getHours().toString().padStart(2, "0"), n = e.getMinutes().toString().padStart(2, "0"), s = e.getSeconds().toString().padStart(2, "0");
  return `${o}:${n}:${s}`;
}, v = () => {
  typeof window < "u" && localStorage.removeItem("lastUserActivity");
}, T = () => {
  const e = S();
  document.cookie = `lastUserActivity=${e}; path=/`;
};
function H() {
  const e = d("lastUserActivity");
  if (!e) return null;
  const o = parseInt(e, 10);
  return isNaN(o) ? null : o;
}
export {
  U as clearCookie,
  C as clearCookies,
  v as clearLocalStorageTimestamp,
  r as cookieOptions,
  d as getClientCookie,
  I as getCurrentTime,
  H as getLastUserActivity,
  z as getQueryParams,
  S as getTimeInMs,
  x as removeClientCookie,
  M as saveAuthCookies,
  y as saveAuthCookiesAlt,
  E as saveCookies,
  T as saveTimestampToLocalStorage,
  h as setClientCookie
};
